export const barOption = {
  legend: {},
  tooltip: {},
  dataset: {
    dimensions: ['product', '2015', '2016', '2017'],
    source: [
      { product: 'Matcha Latte', 2015: 43.3, 2016: 85.8, 2017: 93.7 },
      { product: 'Milk Tea', 2015: 83.1, 2016: 73.4, 2017: 55.1 },
      { product: 'Cheese Cocoa', 2015: 86.4, 2016: 65.2, 2017: 82.5 },
      { product: 'Walnut Brownie', 2015: 72.4, 2016: 53.9, 2017: 39.1 }
    ]
  },
  yAxis: {
    type: 'category'
  },
  xAxis: [{
    type: 'value',
    name: 'Orders',
    min: 0,
    max: 150,
    position: 'top',
    axisLabel: {
      formatter: '{value} Order(s)'
    }
  },
  {
    type: 'value',
    name: '%',
    min: 0,
    max: 100,
    position: 'bottom',
    axisLabel: {
      formatter: '{value} %'
    }
  }
  ],
  series: [{ type: 'bar' }, { type: 'bar' }]
}
